module.exports = __webpack_public_path__ + "img/contents-3@3x.76141604.png";